import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import GlobalStyledScrollBar from "../../components/GlobalStyledScrollBar";
import { RootState } from "../../redux/store";
import DraggableJoinRoom from "../../zoom/DraggableJoinRoom";

const AppLayout = () => {
  const navigate = useNavigate();
  const isOpenJoinRoom: boolean = useSelector(
    (state: RootState) => state.joinRoom?.opened
  );

  useEffect(() => {
    if (isOpenJoinRoom) {
      navigate(-1);
    }
  }, [isOpenJoinRoom]);

  return (
    <>
      <GlobalStyledScrollBar />
      {/*
       * Keep <Outlet /> mounted in a single, stable tree position so opening,
       * minimizing/maximizing, or leaving the telehealth call never remounts
       * the routed page. The call renders as an overlay on top (fixed when
       * fullscreen, floating PIP when minimized) instead of wrapping the
       * Outlet, which previously wiped unsaved SOAP note state. (ECRH-5437)
       */}
      {isOpenJoinRoom && <DraggableJoinRoom />}
      <Outlet />
    </>
  );
};

export default AppLayout;
